import { makeAutoObservable } from "mobx"

export default class Rating {

  constructor(rating={}) {
    this.id = rating.id
    this.quality_score = Math.round(+rating.quality_score || 0)
    this.quality_description = rating.quality_description || ''
    this.professional_score = Math.round(+rating.professional_score || 0)
    this.professional_description = rating.professional_description || ''
    this.created_at = rating.created_at
    this.updated_at = rating.updated_at

    makeAutoObservable(this)
  }
}
